import React from 'react'

export default class ImgFromTexture extends React.Component {
  render() {
    const { texture, scale, width, height, keepDimensions } = this.props
    const { baseTexture, _rotate, _frame } = texture

    const doRotate = _rotate === 2

    const adjustedBase = {
      width: doRotate ? baseTexture.height : baseTexture.width,
      height: doRotate ? baseTexture.width : baseTexture.height,
    }

    const adjustedFrame = {
      width: doRotate ? _frame.height : _frame.width,
      height: doRotate ? _frame.width : _frame.height,
      x: doRotate ? _frame.y : _frame.x,
      y: doRotate ? (baseTexture.width - _frame.x - _frame.width) : _frame.y,
    }

    const path = texture.baseTexture.resource.url
    let _width = width || adjustedFrame.width
    let _height = height || adjustedFrame.height
    let widthFactor = scale ? 1 / scale : (adjustedFrame.width / _width)
    let heightFactor = scale ? 1 / scale : (adjustedFrame.height / _height)
    const rotation = doRotate ? -90 : 0

    if (scale || keepDimensions) {
      if (widthFactor < heightFactor) {
        widthFactor = heightFactor
      } else {
        heightFactor = widthFactor
      }
      _height = adjustedFrame.height / widthFactor
      _width = adjustedFrame.width / heightFactor
    }

    const imgStyle = {
      width: adjustedBase.width / widthFactor,
      height: adjustedBase.height / heightFactor,
      marginLeft: -adjustedFrame.x / widthFactor,
      marginTop: -adjustedFrame.y / heightFactor
    }

    if (doRotate) {
      imgStyle.transform = `rotate(${rotation}deg)`
    }

    return (
      <div
        style={{
          width: _width,
          height: _height,
          overflow: 'hidden',
        }}
      >
        <img
          src={path}
          alt=""
          style={imgStyle}
        />
      </div>
    )
  }
}
